import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import { delegate } from "oj-promise-utils";
import { CustomActor } from "./director/actor/custom/index";
import { Director } from "./director/director";
export const createAnimation = () => {
    const d = new Director();
    return (options) => {
        const _delegate = delegate();
        const a = new CustomActor();
        d.register(a);
        a.apply(options.onupdate);
        if (options.reset)
            a.clear();
        options.onstart().map(x => a.add(...x));
        if (options.start ?? true)
            d.start();
        d.on("stop", () => {
            options.onstop?.();
            _delegate.resolve();
        });
        return {
            promise: _delegate.promise,
            start: () => d.start(),
            stop: () => d.stop(),
        };
    };
};
export class Animate extends MithrilTsxComponent {
    intro;
    outro;
    view(v) {
        return v.children;
    }
    oncreate(v) {
        if (!v.attrs.intro)
            return;
        const dom = v.dom;
        this.intro = createAnimation()(v.attrs.intro(dom));
    }
    onbeforeremove(v) {
        if (!v.attrs.outro)
            return;
        this.intro?.stop();
        const dom = v.dom;
        this.outro = createAnimation()(v.attrs.outro(dom));
        return this.outro.promise;
    }
    onremove(v) {
        this.intro?.stop();
    }
}
export const animateFallBounce = (delay = 0, duration = 400, y = -48) => (dom) => ({
    onupdate: x => {
        dom.style.opacity = x.a;
        dom.style.transform = `translateY(${x.y}px)`;
    },
    onstart: () => [
        [{ a: { from: 0, to: 1 } }, { delay, duration: duration * .5, easing: "easeOutSine" }],
        [{ y: { from: y, to: 0 } }, { delay, duration, easing: "easeOutBounce" }],
    ],
    onstop: () => {
        dom.style.opacity = "";
        dom.style.transform = "";
    }
});
export const animateRiseEase = (delay = 0, duration = 400, y = 48) => (dom) => ({
    onupdate: x => {
        dom.style.opacity = x.a;
        dom.style.transform = `translateY(${x.y}px)`;
    },
    onstart: () => [
        [{ a: { from: 0, to: 1 } }, { delay, duration: duration * .5, easing: "easeOutSine" }],
        [{ y: { from: y, to: 0 } }, { delay, duration, easing: "easeOutSine" }],
    ],
    onstop: () => {
        dom.style.opacity = "";
        dom.style.transform = "";
    }
});
export const animateFadeIn = (delay = 0, duration = 400) => (dom) => ({
    onupdate: x => {
        dom.style.opacity = x.a;
    },
    onstart: () => [
        [{ a: { from: 0, to: 1 } }, { delay, duration, easing: "easeOutSine" }],
    ],
    onstop: () => {
        dom.style.opacity = "";
    }
});
export const animateFadeOut = (delay = 0, duration = 400) => (dom) => ({
    onupdate: x => {
        dom.style.opacity = x.a;
    },
    onstart: () => [
        [{ a: { from: 1, to: 0 } }, { delay, duration, easing: "easeInSine" }],
    ],
    onstop: () => {
        dom.style.opacity = "";
    }
});
export const animateSlideIn = (dir, delay = 0, duration = 400, x = 48) => (dom) => ({
    onupdate: x => {
        dom.style.opacity = x.a;
        dom.style.transform = `translateX(${x.x}px)`;
    },
    onstart: () => {
        return [
            [{ a: { from: 0, to: 1 } }, { delay, duration, easing: "easeOutSine" }],
            [{ x: { from: dir > 0 ? x : -x, to: 0 } }, { delay, duration, easing: "easeOutSine" }],
        ];
    },
    onstop: () => {
        dom.style.opacity = ``;
        dom.style.transform = ``;
    }
});
export const animateSlideOut = (dir, delay = 0, duration = 400, x = 48) => (dom) => ({
    onupdate: x => {
        if (x.a < 1)
            dom.style.position = "absolute";
        dom.style.opacity = x.a;
        dom.style.transform = `translateX(${x.x}px)`;
    },
    onstart: () => {
        return [
            [{ a: { from: 1, to: 0 } }, { delay, duration: duration * .5, easing: "easeInSine" }],
            [{ x: { from: 0, to: dir > 0 ? x : -x } }, { delay, duration, easing: "easeInSine" }],
        ];
    },
    onstop: () => {
        dom.style.opacity = ``;
        dom.style.transform = ``;
    }
});
